import { feeInformationToCreation } from "features/fees/FeeUtils";
import { FeeOverrideForm } from "features/fees/form/FeeOverrideForm";
import { useCommitmentInformationRetrieveSuspense } from "gen/endpoints/commitment-information/commitment-information";
import { useFeeInformationByFeeListSuspense } from "gen/endpoints/fee-information/fee-information";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CommitmentSetupFeeOverridePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["fees"]);

  const { fundFamilyId, commitmentId, feeId } = useRequiredStringParams();

  const { data: commitmentData } = useCommitmentInformationRetrieveSuspense(
    fundFamilyId,
    commitmentId,
  );

  const { data: feeData } = useFeeInformationByFeeListSuspense(
    fundFamilyId,
    feeId,
    {
      security_ownership_id: commitmentId,
    },
    { query: { select: feeInformationToCreation } },
  );

  const navigateToFees = useCallback(() => {
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .setup({})
        .commitments({})
        .commitment({ commitmentId })
        .fees({}).$,
    );
  }, [commitmentId, fundFamilyId, navigate]);

  return (
    <PageContent contentWidth="boxed">
      <PageHeader
        title={t("fees:custom.title", {
          fee_name: feeData.fee.name,
          entity_name: commitmentData.owning_entity_legal_name,
        })}
      />
      <PageBody>
        <FeeOverrideForm
          feeId={feeId}
          overrideLevel={{ security_ownership_id: commitmentId }}
          fundFamilyId={fundFamilyId}
          feeData={feeData}
          onSuccess={navigateToFees}
          onCancel={navigateToFees}
        />
      </PageBody>
    </PageContent>
  );
};
